module.exports = __webpack_public_path__ + "20f84ec0dfbd8c5517f8b03c475f026e.png";